import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ViewSwitcher = ({ currentView, onViewChange, }) => {
    const views = [
        {
            id: 'diagram',
            name: 'Device Diagram',
            icon: '📊',
            description: 'Traditional device overlay view',
        },
        {
            id: 'radial',
            name: 'Radial Dashboard',
            icon: '🎯',
            description: 'Circular sensor arrangement',
        },
        {
            id: 'cards',
            name: '3D Cards',
            icon: '🎴',
            description: 'Depth-based card grid',
        },
        {
            id: 'pipeline',
            name: 'Pipeline Flow',
            icon: '🔄',
            description: 'Animated data flow view',
        },
        {
            id: 'minimal',
            name: 'Minimal Metrics',
            icon: '📈',
            description: 'Clean metric cards',
        },
    ];
    return (_jsxs("div", { className: "mb-6", children: [_jsxs("div", { className: "text-center mb-4", children: [_jsx("h3", { className: "text-lg font-semibold text-gray-800 mb-2", children: "Choose Your View" }), _jsx("p", { className: "text-sm text-gray-600", children: "Select different ways to visualize your sensor data" })] }), _jsx("div", { className: "flex flex-wrap justify-center gap-3 p-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200 shadow-lg", children: views.map((view) => (_jsxs("button", { onClick: () => onViewChange(view.id), className: `
              flex flex-col items-center gap-2 px-6 py-4 rounded-xl transition-all duration-200 min-w-[120px]
              ${currentView === view.id
                        ? 'bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-xl transform scale-105 ring-4 ring-blue-300 ring-opacity-50'
                        : 'bg-white text-gray-700 hover:bg-gray-50 hover:shadow-lg border border-gray-200'}
            `, children: [_jsx("span", { className: "text-2xl", children: view.icon }), _jsx("span", { className: "font-medium text-sm", children: view.name }), _jsx("span", { className: "text-xs opacity-80", children: view.description })] }, view.id))) })] }));
};
export default ViewSwitcher;
